/**
 * When the alerts hub may (re)start. Pure, so the rules are testable
 * without SignalR or the store.
 *
 *   apiSuccess  an authenticated API request succeeded, so the JWT cookie
 *               is fresh: start if signed in, not idle, and down. This is
 *               the only path that covers a failed initial start and a
 *               drop (onclose) after the automatic reconnects gave up.
 *   idleEnd     the user is active again after being idle: start right
 *               away only if the JWT deadline is still ahead; otherwise
 *               wait for the keepalive, which is an apiSuccess.
 */
export const HUB_TRIGGER = {
  apiSuccess: 'apiSuccess',
  idleEnd: 'idleEnd',
};

export const shouldStartHub = ({ trigger, signedIn, idle, disconnected, tokenFresh }) => {
  if (!signedIn || !disconnected) return false;
  if (trigger === HUB_TRIGGER.apiSuccess) return !idle;
  if (trigger === HUB_TRIGGER.idleEnd) return Boolean(tokenFresh);
  return false;
};

/** The stored JWT deadline is still ahead of `now`. */
export const isTokenFresh = (tokenDeadlineAt, now = Date.now()) =>
  typeof tokenDeadlineAt === 'number' && tokenDeadlineAt > now;
